/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';

import { Card, Box, Container, Fade, Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system';

// Wimss context
import {
  useWimssController,
  setIsMobile,
  setCurrentPage,
  setCurrentTexts,
} from 'context';

import { initTexts } from 'utils/syncState';

//import hero pictures and background images
import SandyBeach from 'assets/images/pictures/sandy-beach.png';
import Joinus from 'assets/images/pictures/join-us.png';
import JoinusBanner from 'assets/images/pictures/joinus_banner.png';

const JoinUsHero = () => {
  return (
    <Box sx={{ overflowY: 'hidden' }}>
      <Fade
        in={true}
        style={{
          transitionDelay: 500,
        }}>
        <img
          src={JoinusBanner}
          alt={'Latest JoinUs'}
          style={{
            width: '100%',
            height: 'auto',
            position: 'relative',
            top: 0,
            left: 0,
          }}
        />
      </Fade>
    </Box>
  );
};

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'scale(1.02)',
  },
}));

const TeamContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));

const JoinUs = () => {
  const [controller, dispatch] = useWimssController();
  const { currentLanguage, isMobile, currentPage, currentTexts } = controller;

  const Page = 'join-us';
  const { innerWidth: width } = window;

  const [refreshActBtn, setRefreshActBtn] = useState(true);

  useEffect(() => {
    if (width <= 600) {
      setIsMobile(dispatch, true);
    } else setIsMobile(dispatch, false);
    setCurrentPage(dispatch, Page);
  }, []);

  useEffect(() => {
    // initHero(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (currentLanguage !== '') {
      setRefreshActBtn(false);
    }

    //set pageTexts
    let pageTxts = initTexts(currentLanguage, currentPage);
    setCurrentTexts(dispatch, pageTxts);
    // console.log(currentLanguage);
  }, [currentLanguage, currentPage]);

  useEffect(() => {
    // console.log(currentTexts);
    if (currentTexts !== null && !refreshActBtn) setRefreshActBtn(true);
  }, [currentTexts]);

  return (
    <Box>
      {currentTexts !== null && (
        <Grid
          container
          // columns={{ xs: 4, sm: 8, md: 12 }}
          direction='column'
          spacing={{ xs: 3, md: 4 }}>
          <Grid size={12}>
            <JoinUsHero />
          </Grid>
        </Grid>
      )}
      <TeamContainer maxWidth='xl' sx={{ mt: isMobile ? 0 : 0 }}>
        {currentTexts !== null && (
          <Grid container spacing={isMobile ? 0 : 3}>
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  overflow: 'hidden',
                  width: '100%',
                  height: '100%',

                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}>
                <Stack justifyContent='center' alignItems='center'>
                  <img
                    src={Joinus}
                    style={{
                      maxWidth: isMobile ? '90%' : '100%',
                      height: 'auto',
                    }}
                    alt='Join Us'
                  />
                </Stack>
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={7}
              align='left'
              sx={{ fontSize: isMobile ? '1rem' : '1.2rem' }}>
              {currentTexts[0].description}
            </Grid>
          </Grid>
        )}
      </TeamContainer>
      <Box
        sx={{
          backgroundImage: `url(${SandyBeach})`,
          overflowY: 'auto',
          width: '100vw',
          height: 200,

          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}></Box>
    </Box>
  );
};

export default JoinUs;
